import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c9f74f5")

_pushScopeId("data-v-1c9f74f5")
const _hoisted_1 = { class: "shopping-checked-list" }
const _hoisted_2 = { class: "shopping-checked-list-title-area" }
const _hoisted_3 = { class: "shopping-checked-list-title-area-title" }
const _hoisted_4 = { class: "commonTextBodyStrong shopping-checked-list-title-area-title-text" }
const _hoisted_5 = { class: "commonTextBodyStrong shopping-checked-list-title-area-clearbutton-titletext" }
const _hoisted_6 = { class: "shopping-checked-list-noelement-content" }
const _hoisted_7 = { class: "shopping-checked-list-noelement-content-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ShoppingIngredientListItem = _resolveComponent("ShoppingIngredientListItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.checkedTitle), 1)
      ]),
      _createVNode("div", {
        class: "shopping-checked-list-title-area-clearbutton",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.tappedClearButton(...args)))
      }, [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.clearButtonTitle), 1)
      ])
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getFoodList(), (food) => {
      return (_openBlock(), _createBlock(_component_ShoppingIngredientListItem, {
        key: food.id,
        id: food.id,
        check: food.isChecked,
        ingredientName: food.name,
        hasStock: food.hasStock,
        onCheckClick: _ctx.checkClick,
        onEditClick: _ctx.editClick
      }, null, 8, ["id", "check", "ingredientName", "hasStock", "onCheckClick", "onEditClick"]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createVNode("div", {
      class: "shopping-checked-list-noelement",
      style: _ctx.styleNoElement
    }, [
      _createVNode("div", _hoisted_6, [
        _createVNode("span", _hoisted_7, _toDisplayString(_ctx.noElementMessage), 1)
      ])
    ], 4)
  ]))
})